import React from 'react';
import { Navbar, Hero, Metrics, Testimonials1, PainPoints } from '../components/SectionsPart1';
import { Tomes, Bonuses, Pricing } from '../components/SectionsPart2';
import { Comparison, PremiumBlock, Testimonials2, Guarantee, FAQ, FinalCTA, Footer } from '../components/SectionsPart3';
export default function Home() {
  return <div className="min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-258">
      <Navbar data-id="element-259" />
      <main data-id="element-260">
        <Hero data-id="element-261" />
        <Metrics data-id="element-262" />
        <Testimonials1 data-id="element-263" />
        <PainPoints data-id="element-264" />
        <Tomes data-id="element-265" />
        <Bonuses data-id="element-266" />
        <Pricing data-id="element-267" />
        <Comparison data-id="element-268" />
        <PremiumBlock data-id="element-269" />
        <Testimonials2 data-id="element-270" />
        <Guarantee data-id="element-271" />
        <FAQ data-id="element-272" />
        <FinalCTA data-id="element-273" />
      </main>
      <Footer data-id="element-274" />
    </div>;
}